import React from 'react';
import { Platform, StyleSheet, TouchableOpacity, View } from 'react-native';
import Icon from './Icon';

import { Color, CommonProperties } from '../styles';
import { scale } from '../utils/scale.utils';

const FloatButton = ({ size = 48, iconName, iconSize = 24, iconStyle, style, ...rest }) => {
  const sizeStyles = {
    width: scale(size),
    height: scale(size),
    borderRadius: scale(size / 2),
  };

  return (
    <TouchableOpacity style={[sizeStyles, styles.button, style]} {...rest}>
      <View>
        <Icon size={iconSize} name={iconName} solid={false} style={[styles.icon, iconStyle]} />
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    position: 'absolute',
    bottom: Platform.OS === 'ios' ? scale(90) : scale(70),
    right: scale(20),
    backgroundColor: Color.accent,
    ...CommonProperties.centerAlignment,
    ...CommonProperties.shadow,
  },
  icon: {
    color: Color.primary,
  },
});

export default FloatButton;
